import { STAGES, stage } from 'configs/api';

enum Routes {
  HOME = "HOME",
  DAPPS = "DAPPS",
  PROJECTS = "PROJECTS",
  ASSOCIATED_TOKENS = "ASSOCIATED_TOKENS",
  SUGGESTIONS = "SUGGESTIONS",
  LEARN_EARN = "LEARN_EARN",
  NEWS = "NEWS",
  CAMPAIGNS = "CAMPAIGNS"
}

const routes: Record<STAGES, Record<Routes, string>> = {
  development: {
    [Routes.HOME]: "/",
    [Routes.DAPPS]: "/dapps-admin",
    [Routes.PROJECTS]: "/projects",
    [Routes.ASSOCIATED_TOKENS]: "/associated-tokens",
    [Routes.SUGGESTIONS]: "/suggestions",
    [Routes.LEARN_EARN]: "/learn-earn",
    [Routes.NEWS]: "/news",
    [Routes.CAMPAIGNS]: "/campaigns"
  },
  staging: {
    [Routes.HOME]: "/",
    [Routes.DAPPS]: "/dapps-admin",
    [Routes.PROJECTS]: "/projects",
    [Routes.ASSOCIATED_TOKENS]: "/associated-tokens",
    [Routes.SUGGESTIONS]: "/suggestions",
    [Routes.LEARN_EARN]: "/learn-earn",
    [Routes.NEWS]: "/news",
    [Routes.CAMPAIGNS]: "/campaigns"
  },
  production: {
    [Routes.HOME]: "/",
    [Routes.DAPPS]: "/dapps-admin",
    [Routes.PROJECTS]: "/projects",
    [Routes.ASSOCIATED_TOKENS]: "/associated-tokens",
    [Routes.SUGGESTIONS]: "/suggestions",
    [Routes.LEARN_EARN]: "/learn-earn",
    [Routes.NEWS]: "/news",
    [Routes.CAMPAIGNS]: "/campaigns"
  }
};

export const ROUTES = routes[stage];
